import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Button, Header, Icon } from "semantic-ui-react";
import { observer } from "mobx-react";
import moment from "moment";
import { keys } from "mobx";
import TourStore from "../../../stores/TourStore";
import FormInput from "./FormInput";

@observer
class TourOpenHouse extends Component {
  addOpenHouse = () => {
    const { tourStore } = this.props;
    tourStore.tour.addOpenHouse();
  };

  deleteOpenHouse = index => {
    const { tourStore } = this.props;
    tourStore.tour.deleteOpenHouse(index);
  };

  castToDate = value => {
    return moment(value).unix();
  };

  parseDateToForm = value => {
    if (!value) {
      return value;
    }
    const date = moment.unix(value);
    return date.format(moment.HTML5_FMT.DATETIME_LOCAL);
  };

  render() {
    const { tourStore, t } = this.props;

    return (
      <>
        <Header as="h4">
          {t("clientPanelInfo:openHouse")}
          <Header.Subheader>
            <Button size="small" onClick={this.addOpenHouse}>
              <Icon name="add" />
              {t("clientPanelInfo:addMoreDates")}
            </Button>
          </Header.Subheader>
        </Header>
        <div className="tour-open-house-container">
          {keys(tourStore.tour.openHouse).length ? (
            keys(tourStore.tour.openHouse).map(i => {
              const openHouse = tourStore.tour.openHouse[i];
              return (
                <div className="tour-open-house-row" key={openHouse.key}>
                  <div className="tour-open-house-column">
                    <FormInput
                      type="datetime-local"
                      className="tour-info-openhouse"
                      label={t("clientPanelInfo:openHouseStart")}
                      placeholder="12/15/2019 08:00"
                      dataStore={tourStore}
                      castValue={this.castToDate}
                      parseValue={this.parseDateToForm}
                      name={`tour.openHouse.${i}.start`}
                      errorPointing="below"
                    />
                  </div>
                  <div className="tour-open-house-column">
                    <FormInput
                      type="datetime-local"
                      label={t("clientPanelInfo:openHouseEnd")}
                      placeholder="12/16/2019 18:00"
                      name={`tour.openHouse.${i}.end`}
                      castValue={this.castToDate}
                      parseValue={this.parseDateToForm}
                      error={
                        openHouse.start && openHouse.end && openHouse.start > openHouse.end
                          ? { content: t("clientPanelInfo:dateMustBeforeStart"), pointing: "below" }
                          : null
                      }
                      dataStore={tourStore}
                      errorPointing="below"
                    />
                  </div>
                  <div className="tour-open-house-column tour-open-house-delete">
                    {keys(tourStore.tour.openHouse).length > 1 && (
                      <Button size="small" color="red" onClick={() => this.deleteOpenHouse(i)}>
                        {t("delete")}
                      </Button>
                    )}
                  </div>
                </div>
              );
            })
          ) : (
            <p>{t("clientPanelInfo:noOpenHouseDateAdded")}</p>
          )}
        </div>
      </>
    );
  }
}
TourOpenHouse.propTypes = {
  tourStore: PropTypes.instanceOf(TourStore),
  t: PropTypes.func.isRequired,
};

export default withTranslation()(TourOpenHouse);
